var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"symbol"},[_vm._v("°C")]),_c('label',{staticClass:"switch"},[_c('input',{attrs:{"type":"checkbox"},on:{"click":_vm.setDegreeUnit}}),_c('span',{staticClass:"slider round"})]),_c('div',{staticClass:"symbol"},[_vm._v("°F")])])
}
var staticRenderFns = []

export { render, staticRenderFns }